module.exports = __webpack_public_path__ + "img/5d146a990cb31f1edb1e5ed6864435f2.3a6f25b6.jpg";